import Vue from 'vue'
import Vuex from 'vuex'
import { setHtmlLang } from './util/lang'

Vue.use(Vuex)

const localStoragePlugin = store => {
  // 当 store 初始化后调用
  store.subscribe((mutation, state) => {
    if (mutation.type === 'setLang') {
      window.localStorage.setItem('lang', state.lang)
      setHtmlLang(state.lang)
    }
  })
}

export default new Vuex.Store({
  state: {
    lang: 'en'
  },
  mutations: {
    setLang (state, lang) {
      state.lang = lang
    }
  },
  actions: {
    setLang ({ commit }, lang) {
      commit('setLang', lang)
    }
  },
  plugins: [localStoragePlugin]
})
